import { LanguageWithLinkType } from 'src/templates/article-template/dto';
import { Maybe } from '@/types/maybe';

export const findDefaultDocumentLink = (
    availableLanguages: Maybe<LanguageWithLinkType[]>,
    language: string,
): string | undefined => {
    if (!availableLanguages || availableLanguages.length === 0) {
        return undefined;
    }

    const languageItem = availableLanguages.find(
        (langItem) => langItem.language.id?.toUpperCase() === language.toUpperCase(),
    );

    return languageItem?.link?.uri ?? availableLanguages[0]?.link?.uri;
};

export const isPdfLink = (url: string | undefined): boolean => {
    if (!url) {
        return false;
    }

    // Remove query parameters and fragments for accurate extension check
    const cleanUrl = url.split('?')[0].split('#')[0];
    return cleanUrl.toLowerCase().endsWith('.pdf');
};

export const isDownloadableLink = (url: string | undefined): boolean => {
    if (!url) {
        return false;
    }

    const cleanUrl = url.split('?')[0].split('#')[0];
    return (
        cleanUrl.toLowerCase().endsWith('.pdf') ||
        cleanUrl.toLowerCase().endsWith('docx') ||
        cleanUrl.toLowerCase().endsWith('.xlsx')
    );
};
